"use client"

import { useTranslations } from "@/lib/intl/use-translations"
import { useQuizProgress } from "@/components/quiz/progress-context"

/**
 * Thin progress bar that sits directly under the chrome header.
 * Pulls live step state from the wizard via `QuizProgressContext`.
 *
 * Rendered in the layout so it spans the full viewport width, not
 * the wizard's 640px column. Empty (zero-width fill) until the
 * wizard mounts and reports its first step.
 */
export function QuizProgressBar() {
  const t = useTranslations("quiz")
  const progress = useQuizProgress()
  const pct =
    progress && progress.total > 0
      ? Math.min(100, Math.max(0, (progress.current / progress.total) * 100))
      : 0
  return (
    <div
      role="progressbar"
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={Math.round(pct)}
      aria-label={t("progressLabel")}
      className="h-[3px] w-full bg-neutral-100"
    >
      <div
        className="bg-deep-blue-900 h-full transition-[width] duration-400 ease-out"
        style={{ width: `${pct}%` }}
      />
    </div>
  )
}
